import React from 'react';
import { FiInfo } from 'react-icons/fi';
import TooltipOverlay from './tooltip/Tooltip';

interface InfoBlockProps {
    main: React.ReactNode;
    label: React.ReactNode;
    tooltipContent?: React.ReactNode;
    showTooltip?: boolean;
    tooltipId?: string;
    mainClassName?: string;
    infoIconSize?: number;
    infoIconClassName?: string;
    labelClass?: string;
}

const InfoBlock: React.FC<InfoBlockProps> = ({
    main,
    label,
    tooltipContent,
    showTooltip = false,
    mainClassName = '',
    infoIconSize = 14,
    infoIconClassName = 'ml-1',
    labelClass = '',
}) => (
    <>
        <div className={`d-flex align-items-center justify-content-center ${mainClassName}`}>
            {main}
            {showTooltip && tooltipContent && (
                <TooltipOverlay content={tooltipContent}>
                    <FiInfo size={infoIconSize} className={infoIconClassName} />
                </TooltipOverlay>
            )}
        </div>
        <div className={labelClass}>{label}</div>
    </>
);

export default InfoBlock;
